import React from 'react'
import { fontPageBlueImage, isecurionLogo, reportDate, reportTestingName, } from './Part1/FrontPage/FrontPage-Support'
import { confidentialMaterial1, confidentialMaterial2, confidentialMaterial3, confidentialMaterial4 } from './Part1/Page1/Support'
import { Document, Packer, SectionType, BorderStyle, PageBorderDisplay, PageBorderOffsetFrom, PageBorderZOrder, PageOrientation, ImageRun, Paragraph, AlignmentType, TableOfContents, StyleLevel, WidthType, LevelFormat, convertInchesToTwip, TextRun, HeadingLevel, Header, Table, TableRow, TableCell, ShadingType, PageBreak, TabStopType, TabStopPosition, TableLayoutType, TabStop, Footer, PageNumber, NumberFormat, VerticalAlign } from 'docx';
import { saveAs } from 'file-saver';
import { url } from '../../../../../constants/url';
import { toast } from 'react-toastify';
import { documentFirstTable, documentHeading2, documentSecondTable, documnetHeading } from './Part1/Page2/Page2-Support';
import { page3firstTable, page3Heading, page3Heading2, page3Heading3, page3SecondTable, page3Text, page3ThirdTable } from './Part1/Page3/Page3-Support';
import { TOCHeadings } from './Part1/Page4/TableOfContent';
import homepageImage from '../../../../../Assests/ReportImages/isecurion1.png';
import { bulletFour, bulletOne, bulletThree, bulletTwo, objectiveHeading, objectiveImage, objectiveSecondImage, objectiveText, scopeHeading, scopeImage, scopeTable, scopeText } from './Part1/Page5/Page5-Support'
import { imageThree, recommandation1, recommandation2, recommmandation, summaryHeading, summaryImage, summaryText, summaryText2, summaryText3, userRole, userRoleImpact } from './Part1/Page6/Page6-Support'
import { accrualPhase, accrualPhaseText, accrualPhasebullet1, accrualPhasebullet2, accrualPhasebullet3, imageFour, methodologyHeading, setUpAndMethodology } from './Part2/Page7/Page7-Support'
import { acclimatizePhase, acclimatizePhaseText, admittancePhase, admittancePhaseText, affirmationPhase, affirmationPhaseText, analysisPhase, analysisPhaseText, tools, toolsTable } from './Part2/Page8/Page8-Support'
import { coveredPoint1, coveredPoint10, coveredPoint2, coveredPoint3, coveredPoint4, coveredPoint5, coveredPoint6, coveredPoint7, coveredPoint8, coveredPoint9, followingTests, strongPoint1, weakPoint1 } from './Part2/Page9/Page9-Support';
import { oWASPExcelBelow, oWASPExcelBelow1, oWASPExcelBelow2, testingCategory } from './Part2/Page10/Page10-Support';
import { top10ListTable, top10list } from './Part2/Page11/Page11-Support';
import { exploitation, exploitationTable, mapping, observartionSummaryText, ratingTableSentence, severityCategory, summaryNote, vulnerabilityTable } from './Part2/Page12/Page12-Support';
import { chartDescription, severityLevelTable, severityRiskRating, tableDescription } from './Part2/Page13/Page13-Support';
import { findingsHeading, findingsText, findingsText2, imagefive } from './Part3/Page15';
import { lastPage } from './Part3/ReportEnd';



export async function WebReportSkeleton(props) {

    const {
        date, customerName, author, clientName, consultantName, applicationName, applicationURL, testStartDate,
        testEndDate, environmentType, emailVer, logout, userRoles, critical, high, medium, low, info, vulCount, brokenAccess,
        cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures,
        securityFailures, ssrf, generatedReportData, pocDetails, loading, setLoading, textAreaValue, testingType,
        weakPoints, strongPoints, image, imageUrl
    } = props



    const reportName = `${applicationName} Web Application Penetration Testing Report`

    const frontPage1 = isecurionLogo
    const frontPage2 = fontPageBlueImage
    const frontPage3 = reportDate(date)
    const FrontPage4 = reportTestingName(reportName)

    // page 1
    const page11 = confidentialMaterial1
    const page12 = confidentialMaterial2
    const page13 = confidentialMaterial3(customerName);
    const page14 = confidentialMaterial4(customerName)


    // page 2
    const page21 = documnetHeading
    const page22 = documentFirstTable(reportName)
    const page23 = documentHeading2
    const page24 = documentSecondTable(author, date, customerName)

    //page 3
    const page31 = page3Heading
    const page32 = page3Text
    const page33 = page3firstTable(date)
    const page34 = page3Heading2
    const page35 = page3SecondTable(clientName, customerName)
    const page36 = page3Heading3
    const page37 = page3ThirdTable(consultantName)

    //page 4
    const page41 = TOCHeadings

    // page 5
    const page51 = objectiveImage
    const page52 = objectiveHeading
    const page53 = objectiveText(customerName)
    const page54 = objectiveSecondImage
    const page55 = bulletOne(applicationName)
    const page56 = bulletTwo
    const page57 = bulletThree
    const page58 = bulletFour
    const page521 = scopeImage
    const page522 = scopeHeading
    const page523 = scopeText(customerName)
    const page524 = scopeTable(applicationURL)

    // page 6
    const page61 = imageThree
    const page62 = summaryHeading
    const page63 = summaryText(customerName, applicationName, testStartDate, testEndDate)
    const page64 = summaryImage
    const page65 = summaryText2(customerName)
    const page66 = summaryText3(environmentType, testingType)
    const page67 = userRole(textAreaValue)
    const page68 = testingType !== "Black box testing methodology (Unauthenticated Testing)" ? userRoleImpact : ''
    const page69 = recommmandation
    const page60 = recommandation1
    const page601 = recommandation2

    //page 7
    const page71 = imageFour
    const page72 = methodologyHeading
    const page73 = setUpAndMethodology
    const page74 = accrualPhase
    const page75 = accrualPhaseText
    const page76 = accrualPhasebullet1
    const page77 = accrualPhasebullet2
    const page78 = accrualPhasebullet3

    //page 8
    const page81 = acclimatizePhase
    const page82 = acclimatizePhaseText
    const page83 = analysisPhase
    const page84 = analysisPhaseText
    const page85 = admittancePhase
    const page86 = admittancePhaseText
    const page87 = affirmationPhase
    const page88 = affirmationPhaseText
    const page89 = tools
    const page890 = toolsTable

    //page 9
    const page92 = followingTests
    const page921 = coveredPoint1
    const page922 = coveredPoint2
    const page923 = coveredPoint3
    const page924 = coveredPoint4
    const page925 = coveredPoint5
    const page926 = coveredPoint6
    const page927 = coveredPoint7
    const page928 = coveredPoint8
    const page929 = coveredPoint9
    const page9210 = coveredPoint10
    const page931 = weakPoint1(weakPoints)
    const page941 = strongPoint1(strongPoints)

    //page 10
    const page102 = testingCategory
    const page1031 = oWASPExcelBelow
    const page1032 = oWASPExcelBelow1
    const page1033 = oWASPExcelBelow2

    //page 11
    const page111 = top10list
    const page112 = top10ListTable(brokenAccess, cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures, securityFailures, ssrf)

    //page 12
    const page122 = observartionSummaryText(vulCount, applicationName)
    const page1221 = summaryNote
    const page1222 = mapping
    const page1223 = severityCategory
    const page1224 = exploitation
    const page1225 = exploitationTable
    const page1231 = vulnerabilityTable
    const page123 = ratingTableSentence

    //page 13
    const page131 = severityRiskRating
    const page132 = severityLevelTable(critical, high, medium, low, info)
    const page133 = tableDescription
    const page134 = chartDescription

    // page 15
    const page151 = imagefive
    const page152 = findingsHeading
    const page153 = findingsText
    const page154 = findingsText2

    // Last page
    const lastpage = lastPage


    const design = {
        page: {
            margin: { top: 1550, right: 500, bottom: 800, left: 500, header: 500, footer: 500 },
            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            borders: {
                pageBorderBottom: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderLeft: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderRight: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorderTop: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                pageBorders: {
                    display: PageBorderDisplay.ALL_PAGES,
                    offsetFrom: PageBorderOffsetFrom.TEXT,
                    zOrder: PageBorderZOrder.FRONT,
                },
            },
            type: SectionType.CONTINUOUS,
        },
    }

    const imageData = await fetch(homepageImage).then(response => response.blob());
    const footerIsecurion = new ImageRun({
        type: 'png',
        data: await imageData.arrayBuffer(),
        transformation: {
            width: 70,
            height: 18
        },
    });


    const methodology4_1 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 100 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Methodology",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_2 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 50 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Areas Covered during Penetration Testing",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_3 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 550, after: 10 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Weak Points",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_4 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 550, after: 10 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Strong Points",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_5 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 50, after: 400 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Benchmarking with OWASP TOP 10",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_6 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 50, after: 200 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Observation Summary",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })
    const methodology4_7 = new Paragraph({
        indent: { left: 1200 },
        spacing: { before: 50, after: 500 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Findings Summary",
                size: 32,
                color: "0f0f3f",
                font: "Gill Sans MT",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_3,
    })

    // for page 14 Finding summary Table ----start------
    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 5, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    indent: { left: 600 },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 28, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Observed Vulnerability",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Risk Rating",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                }),
                new TableCell({
                    width: { size: 53, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })
                    ],
                    shading: { type: ShadingType.SOLID, color: "1F497D" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    }
                })
            ],
        }),
    ];

    const sortedVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    sortedVulnerabilities.forEach((vulnerability, index) => {
        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";
            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }
            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                indent: { left: 60 },
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerabilityName,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: severity,
                                        font: "Calibri",
                                        size: 22,
                                        color: "0f0f3f",
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: {
                            type: ShadingType.SOLID,
                            color: severity === "Critical" ? "c00000" : severity === "High" ? "ff0000" : severity === "Medium" ? "ffc000" : severity === "Low" ? "ffff00" : severity === "Information" ? "00b050" : "ffffff"
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),

                    new TableCell({
                        width: { size: 53, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    indent: { left: 600 },
                                    spacing: { before: 50, after: 50 },
                                    alignment: AlignmentType.LEFT,
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Calibri",
                                            size: 22,
                                            color: "0f0f3f",
                                            italics: false
                                        })
                                    ]
                                })
                            )

                        ],
                        shading: { type: ShadingType.SOLID, color: "ffffff" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })

                ],
            })
        );
    });
    // for page 14 Finding summary Table ----end------


    // for vulnerability Table ----start------
    const MAX_WIDTH = 670;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            const dimensions = await getImageDimensions(imageData);
            return new ImageRun({
                data: imageData,
                transformation: { width: dimensions.width, height: dimensions.height },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    const sortVulnerabilities = generatedReportData.sort((a, b) => b.cvssScore - a.cvssScore);
    const docSections = sortVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];

        for (let i = 0; i < (vulnerability.poc || []).length; i++) {
            const pocText = vulnerability.poc[i]?.poc || "";
            const matchingPocDetails = pocDetails.find(
                (p) => p.data.vulId === vulnerability._id
            );
            const match = pocText.match(/^(Scenario\s*[123])\s*(.*)$/);
            if (match) {
                combinedContent.push(
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: match[1],
                                size: 24,
                                bold: true
                            }),
                        ],
                    }),
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: match[2],
                                size: 24,
                            }),
                        ],
                    })
                );
            } else {
                combinedContent.push(
                    new Paragraph({
                        indent: { left: 600, right: 600 },
                        children: [
                            new TextRun({
                                text: pocText,
                                size: 24,
                            }),
                        ],
                    })
                )
            }
            if (matchingPocDetails) {
                const pocFiles = matchingPocDetails.data.files || [];
                const currentPocFiles = pocFiles.filter(
                    (file) => file.pocFolder === `poc-${i}`
                );
                if (currentPocFiles.length > 0) {
                    for (let j = 0; j < currentPocFiles.length; j++) {
                        const file = currentPocFiles[j];
                        if (file.url) {
                            try {
                                const pocImageData = await fetchImageAsBase64(file.url);
                                const dimensions = await getImageDimensions(pocImageData);

                                const imageRun = new ImageRun({
                                    data: pocImageData.split(",")[1],
                                    transformation: {
                                        width: dimensions.width,
                                        height: dimensions.height,
                                    },
                                });
                                combinedContent.push(
                                    new Paragraph({
                                        indent: { left: 600, right: 600 },
                                        spacing: { before: 200, after: 300 },
                                        children: [imageRun],
                                    })
                                );
                            } catch (error) {
                                console.error(
                                    `❌ Error fetching image for vulnerability`,
                                );
                            }
                        }
                    }
                } else {
                    console.log(
                        `No files found for vulnerability`
                    );
                }
            }
        }

        function getSeverityAndColor(riskScore) {
            let severity = "";
            let color = "";

            if (riskScore >= 9.0 && riskScore <= 10.0) {
                severity = "Critical";
                color = "c00000";
            } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                severity = "High";
                color = "ff0000";
            } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                severity = "Medium";
                color = "ffc000";
            } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                severity = "Low";
                color = "ffff00";
            } else {
                severity = "Informational";
                color = "00b050";
            }

            return { severity, color };
        }

        const riskScore = vulnerability.cvssScore;
        const { severity, color } = getSeverityAndColor(riskScore);

        return [
            new Paragraph({
                heading: HeadingLevel.HEADING_3,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 1100 },
                spacing: { before: 150, after: 400 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                pageBreakBefore: true,
                children: [
                    new TextRun({
                        text: vulnerability.vulnerabilityName,
                        size: 24,
                        color: "0f0f3f",
                        font: "Gill Sans MT",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10035, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Vulnerability",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerabilityName,
                                            font: "Calibri",
                                            size: 22,
                                            color: "1E1B48",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Description",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.description,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "OWASP Category ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true.valueOf,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.OWASP,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected URL Address ",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.affectedParameter.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 10, after: 10 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: url,
                                            font: "Calibri",
                                            size: 22,
                                            color: "1E1B48",
                                            italics: false
                                        })]
                                    })
                                ),

                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Risk/Impact",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.risk,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Ease of Exploitation",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.exploitation,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS String",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: vulnerability.cvssString,
                                        font: "Calibri",
                                        size: 22,
                                        color: "1E1B48",
                                        italics: false
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVSS Score/ Risk Rating",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [new Paragraph({
                                    spacing: { before: 80, after: 80 },
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 100 },
                                    children: [new TextRun({
                                        text: `${riskScore} / ${severity}`,
                                        font: "Calibri",
                                        size: 22,
                                        color: color,
                                        italics: false,
                                        bold: true
                                    })
                                    ]
                                })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation/ Solution",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                spacing: { before: 80, after: 80 },
                                indent: { left: 100 },
                                children: [
                                    new Paragraph({
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: "ISECURION recommends:",
                                                font: "Calibri",
                                                size: 22,
                                                color: "1E1B48",
                                                italics: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [
                                                new TextRun({
                                                    text: bulletText.trim(),
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "1E1B48",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    )
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),


                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2035, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Calibri",
                                            size: 22,
                                            color: "ffffff",
                                            bold: true,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "7ec4fe" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8000, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 30, after: 500 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "",
                                            font: "Calibri",
                                            size: 22,
                                            color: "1E1B48",
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "bfe2ff" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "3CA6FE" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({
                indent: { left: 600 },
                spacing: { before: 200, line: 356 },
                pageBreakBefore: true,
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "0f0f3f",
                        font: "Calibri",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);

    // for vulnerability Table ----end------

    let clientImageRun;

    if (image) {
        try {
            const clientImageData = await getBase64(image)
            clientImageRun = new ImageRun({
                data: clientImageData,
                transformation: { width: 100, height: 25 }
            })
            console.log("Selected", clientImageRun);
        }
        catch (error) {
            console.error('Error while uploading client image:', error);
        }
    } else if (imageUrl) {
        try {
            const clientImageData = await fetchImageAsBase64(imageUrl);
            clientImageRun = new ImageRun({
                data: clientImageData.split(',')[1],
                transformation: { width: 100, height: 25 }
            });
        } catch (error) {
            console.error('Error while fetching client image from URL:', error);
        }
    }


    const doc = new Document({
        creator: "ISECURION",
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "4.%1",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 32,
                                    bold: true,
                                    color: "0f0f3f",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "5.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "#0f0f3f", bold: true, size: 24 },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "0f0f3f",
                                },
                            },
                        },

                    ]
                }
            ]
        },
        features: { updateFields: true },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Calibri",
                        bold: false,
                        size: 22,
                        color: "0f0f3f",
                    },
                },
                heading2: {
                    run: {
                        size: 40,
                        color: "0189f9",
                        font: "Gill Sans MT",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
                heading3: {
                    run: {
                        font: "Gill Sans MT",
                        size: 24,
                        bold: true,
                        color: "0f0f3f",
                        italics: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },

                paragraph: {
                    run: {
                        italics: false
                    }
                }

            },
            paragraphStyles: [
                {
                    id: "numberedPara",
                    name: "Numbered Para",
                    basedOn: "Normal",
                    next: "Normal",
                    quickFormat: true,
                    run: { font: "Gill Sans MT(Headings)", size: 24, bold: true, },
                    paragraph: {
                        spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
                        rightTabStop: TabStopPosition.MAX,
                        leftTabStop: 453.543307087,
                        numbering: { reference: "my-crazy-numbering", level: 1 },
                    },
                },
            ]
        },
        sections: [
            {
                properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                children: [frontPage1, frontPage2, frontPage3, FrontPage4],
                pageBreakBefore: true,
            },
            //---------------------- front page End -------------------

            //---------------------- page 1 Start----------------------
            {
                properties: {
                    page: {
                        margin: { top: -800, right: 500, bottom: -500, left: 500, header: 500, footer: 500 },
                        size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                        borders: {
                            pageBorderBottom: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderLeft: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderRight: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorderTop: { style: BorderStyle.DASH_SMALL_GAP, size: 1 * 8, color: "1e8ff9" },
                            pageBorders: {
                                display: PageBorderDisplay.ALL_PAGES,
                                offsetFrom: PageBorderOffsetFrom.TEXT,
                                zOrder: PageBorderZOrder.FRONT,
                            },
                        },
                        type: SectionType.CONTINUOUS,
                    },
                },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                children: [
                                                    new Paragraph({
                                                        indent: { left: 200, },
                                                        width: { size: 50, type: WidthType.PERCENTAGE },
                                                        children: [new TextRun({
                                                            text: "Web Application Penetration Testing Report",
                                                            font: "Calibri",
                                                            size: 24,
                                                            italics: false
                                                        })],
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                                },
                                                margins: { top: 100, bottom: 100, left: 100, right: 100 },
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({ indent: { right: 2000 } })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                children: [
                                                    new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 18, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({ indent: { left: 200 }, children: [footerIsecurion] })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 68, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.CENTER,
                                                        children: [new TextRun({
                                                            text: "Copyright © 2026 ISECURION",
                                                            font: "Calibri",
                                                            size: 18,
                                                            italics: false
                                                        })]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 14, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.CENTER,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 28,
                                                                bold: true
                                                            })
                                                        ]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    })
                },
                children: [page11, page12, page13, page14],
                pageBreakBefore: true,
            },
            //---------------------- page 1 End------------------------
            //---------------------- page 2 Start----------------------
            {
                properties: { ...design },
                children: [page21, page22, page23, page24],
                pageBreakBefore: true,
            },
            //---------------------- page 2 End------------------------
            //---------------------- page 3 Start----------------------
            {
                properties: { ...design },
                children: [page31, page32, page33, page34, page35, page36, page37],
                pageBreakBefore: true,
            },
            //---------------------- page 3 End------------------------

            //---------------------- page 4 Start----------------------
            {
                properties: { ...design },
                children: [
                    page41,
                    new Table({
                        width: { size: 90, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        indent: { size: 500, type: WidthType.DXA },
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 90, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
                pageBreakBefore: true,
            },

            //---------------------- page 4 End------------------------

            //---------------------- page 5 Start----------------------
            {
                properties: { ...design },
                children: [page51, page52, page53, page54, page55, page56, page57, page58, page521, page522, page523, page524],
                pageBreakBefore: true,
            },
            //---------------------- page 5 End------------------------

            //---------------------- page 6 Start----------------------
            {
                properties: { ...design },
                children: [page61, page62, page63, page64, page65,
                    new Paragraph({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        indent: { left: 600, right: 600 },
                        // spacing: { before: 250 },
                        spacing: { line: 276, before: 250 },
                        alignment: AlignmentType.LEFT,
                        children: [
                            new TextRun({
                                text: `Testing was performed on the ${environmentType} Environment. ${testingType} ${testingType === "Black box testing methodology (Unauthenticated Testing)"
                                        ? "was performed."
                                        : "was performed with below-mentioned user roles:"
                                    }`,
                                size: 24,
                                font: "Calibri",
                                color: '0f0f3f',
                                italics: false
                            }),
                        ],
                    }),
                    page67,
                    page68,
                    page69, page60, page601],
                pageBreakBefore: true,
            },
            //---------------------- page 6 End------------------------

            //---------------------- page 7 Start----------------------
            {
                properties: { ...design },
                children: [page71, page72, methodology4_1, page73, page74, page75, page76, page77, page78],
                pageBreakBefore: true,
            },
            //---------------------- page 7 End------------------------

            //---------------------- page 8 Start----------------------
            {
                properties: { ...design },
                children: [page81, page82, page83, page84, page85, page86, page87, page88, page89, page890],
                pageBreakBefore: true,
            },
            //---------------------- page 8 End------------------------

            //---------------------- page 9 Start----------------------
            {
                properties: { ...design },
                children: [methodology4_2, page92, page921, page922, page923, page924, page925, page926, page927, page928, page929, page9210, methodology4_3, page931, methodology4_4, page941],
                pageBreakBefore: true,
            },
            //---------------------- page 9 End------------------------

            //---------------------- page 10 Start---------------------
            {
                properties: { ...design },
                children: [methodology4_5, page102, page1031, page1032, page1033],
                pageBreakBefore: true,
            },
            //---------------------- page 10 End-----------------------

            //---------------------- page 11 Start---------------------
            {
                properties: { ...design },
                children: [page111, page112],
                pageBreakBefore: true,
            },
            //---------------------- page 11 End-----------------------

            //---------------------- page 12 Start---------------------
            {
                properties: { ...design },
                children: [methodology4_6, page122, page1221, page1222, page1223, page123, page1231, page1224, page1225],
            },
            //---------------------- page 12 End-----------------------

            //---------------------- page 13 Start---------------------
            {
                properties: { ...design },
                children: [page131, page132, page133, page134],
                pageBreakBefore: true,
            },
            //---------------------- page 13 End-----------------------

            //---------------------- page 14 Start---------------------
            {
                properties: { ...design },
                children: [methodology4_7,
                    new Table({
                        width: { size: 89, type: WidthType.PERCENTAGE },
                        alignment: AlignmentType.CENTER,
                        spacing: { before: 1200 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        },
                        rows: rows
                    })
                ],
                pageBreakBefore: true,
            },
            //---------------------- page 14 End-----------------------

            //---------------------- page 15 Start --------------------
            {
                properties: { ...design },
                children: [page151, page152, page153, page154],
                pageBreakBefore: true,
            },
            //---------------------- page 15 End ----------------------


            //---------------------- page 16 Start --------------------
            {
                properties: { ...design },
                children: [
                    ...docSectionsResolved.flat()
                ],
                pageBreakBefore: true,
            },
            //---------------------- page 16 End ----------------------

        ]
    })

    try {
        setLoading(true)
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.status === 200) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `${reportName}.docx`);
            });
            setLoading(false)
            return
        }
        if (response.status !== 200) {
            setLoading(false)
            return
        }
        if (response.status === 440) {
            setLoading(false)
            logout()
            toast.error("User logout due to inactivity", {
                position: 'top-right',
                autoClose: 2500,
                pauseOnHover: false,
            });
            return
        }

    } catch (error) {
        console.log(error)
    }

}


